
require('../../components/atoms/disclosure/disclosure.js')
require('../../components/atoms/dropdown-field/dropdown-field.js')
require('../../components/atoms/figure/figure.js')
require('../../components/atoms/share-button/share-button.js')
require('../../components/atoms/text-field/text-field.js')
require('../../components/atoms/video-embed/video-embed.js')
require('../../components/molecules/donation-row/donation-row.js')
require('../../components/molecules/form-container/form-container.js')
require('../../components/organisms/campaign-spread/campaign-spread.js')
require('../../components/organisms/card-carousel/card-carousel.js')
require('../../components/organisms/content-highlight/content-highlight.js')
require('../../components/organisms/cookie-preferences/cookie-preferences.js')
require('../../components/organisms/cookie-save/cookie-save.js')
require('../../components/organisms/featured-card-carousel/featured-card-carousel.js')
require('../../components/organisms/notification-block/notification-block.js')
require('../../components/organisms/photo-parallax/photo-parallax.js')
require('../../components/organisms/ragged-card-grid/ragged-card-grid.js')
require('../../components/organisms/theme-card-carousel/theme-card-carousel.js')
require('../../components/structures/menu-bar/menu-bar.js')
require('../../components/structures/menu-overlay/menu-overlay.js')
require('../../components/structures/notification-bar/notification-bar.js')
require('../../components/structures/skip-to-main/skip-to-main.js')
require('../../components/structures/whatsapp-button/whatsapp-button.js')
import { getCookie } from 'assets/scripts/utilities/simple-cookie.js'
import { cookies, requiredCookies, updateConsent } from 'assets/scripts/utilities/datalayer.consent.js'

// There are 4 load events:
// - 'init-immediate': (compiles when the script is loaded; blocks rendering)
// - 'init-load': (on DOMContentLoaded event; does not block rendering)
// - 'init-after-load': (on Load event, slightly after DOMContentLoaded)
// - 'init-delayed-load': (after Load event, with a slight delay, for iframes and such)
// Usually, the 'init-load' event will suffice.
window.dispatchEvent(new CustomEvent('init-immediate'))
window.addEventListener('DOMContentLoaded', () => window.dispatchEvent(new CustomEvent('init-load')))
window.addEventListener('load', () => window.dispatchEvent(new CustomEvent('init-after-load')))
window.addEventListener('load', () => window.setTimeout(() => window.dispatchEvent(new CustomEvent('init-delayed-load')), 500))

// Focus stuff
document.addEventListener('keydown', () => document.documentElement.classList.add('key-pressed'))
document.addEventListener('mousedown', () => document.documentElement.classList.remove('key-pressed'))
document.addEventListener('touchstart', () => document.documentElement.classList.remove('key-pressed'))

// Show debug styles on L hotkey and grid on G hotkey when document is focussed.
// if (WEBPACK_ENV.ENV === 'development') {
if (window.location.href.indexOf('groenlinks.local') !== -1 || window.location.href.indexOf('127.0.0.1') !== -1) {
  document.addEventListener('keydown', event => {
    if (event.target !== document.body) {
      return
    }

    if (event.key === 'l') {
      document.documentElement.classList.toggle('debug-layout')
    } else if (event.key === 'g') {
      document.documentElement.classList.toggle('debug-grid')
    }

    document.cookie = `debug-layout=${document.documentElement.classList.contains('debug-layout')}; path=/;`
    document.cookie = `debug-grid=${document.documentElement.classList.contains('debug-grid')}; path=/;`
  })

  document.documentElement.classList.toggle('debug-layout', document.cookie.indexOf('debug-layout=true') !== -1)
  document.documentElement.classList.toggle('debug-grid', document.cookie.indexOf('debug-grid=true') !== -1)
}

// Google Consent Mode v2
function initialiseConsentEvents () {
  window.dataLayer = window.dataLayer || []
  function gtag () { dataLayer.push(arguments) }
  gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
    functionality_storage: 'denied',
    personalization_storage: 'denied',
    security_storage: 'denied'
  })
  window.dataLayer.push({
    originalLocation:
      document.location.protocol + '//' + document.location.hostname + document.location.pathname + document.location.search
  })
}
initialiseConsentEvents()

window.addEventListener('init-load', () => {
  var currentCookies = new Map(cookies.map((cookie) => [cookie, getCookie(cookie) === 'yes' || requiredCookies.includes(cookie) ? 'yes' : 'no']))
  currentCookies.forEach((isAccepted, cookie) => updateConsent(cookie, isAccepted === 'yes'))
})
